/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ComponentTypeOneResponseDto,
  CreateComponentTypeRequestDto,
  ListComponentTypesResponseDto,
  UpdateComponentTypeRequestDto,
} from '../models/index';
import {
    ComponentTypeOneResponseDtoFromJSON,
    ComponentTypeOneResponseDtoToJSON,
    CreateComponentTypeRequestDtoFromJSON,
    CreateComponentTypeRequestDtoToJSON,
    ListComponentTypesResponseDtoFromJSON,
    ListComponentTypesResponseDtoToJSON,
    UpdateComponentTypeRequestDtoFromJSON,
    UpdateComponentTypeRequestDtoToJSON,
} from '../models/index';

export interface ComponentTypeControllerCreateRequest {
    createComponentTypeRequestDto: CreateComponentTypeRequestDto;
}

export interface ComponentTypeControllerDeleteRequest {
    id: string;
}

export interface ComponentTypeControllerFindAllRequest {
    limit: number;
    page: number;
    mappingId?: string;
    tableFilterFieldValue?: string;
    tableFilterFieldName?: string;
    mappingKey?: ComponentTypeControllerFindAllMappingKeyEnum;
    operator?: ComponentTypeControllerFindAllOperatorEnum;
    q?: string;
}

export interface ComponentTypeControllerFindByIdRequest {
    id: string;
}

export interface ComponentTypeControllerUpdateRequest {
    id: string;
    updateComponentTypeRequestDto: UpdateComponentTypeRequestDto;
}

/**
 * 
 */
export class KnowledgeBaseComponentTypeApi extends runtime.BaseAPI {

    /**
     */
    async componentTypeControllerCreateRaw(requestParameters: ComponentTypeControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['createComponentTypeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createComponentTypeRequestDto',
                'Required parameter "createComponentTypeRequestDto" was null or undefined when calling componentTypeControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/component-types`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateComponentTypeRequestDtoToJSON(requestParameters['createComponentTypeRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async componentTypeControllerCreate(requestParameters: ComponentTypeControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.componentTypeControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async componentTypeControllerDeleteRaw(requestParameters: ComponentTypeControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling componentTypeControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/component-types/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async componentTypeControllerDelete(requestParameters: ComponentTypeControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.componentTypeControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async componentTypeControllerFindAllRaw(requestParameters: ComponentTypeControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListComponentTypesResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling componentTypeControllerFindAll().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling componentTypeControllerFindAll().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['mappingId'] != null) {
            queryParameters['mappingId'] = requestParameters['mappingId'];
        }

        if (requestParameters['tableFilterFieldValue'] != null) {
            queryParameters['tableFilterFieldValue'] = requestParameters['tableFilterFieldValue'];
        }

        if (requestParameters['tableFilterFieldName'] != null) {
            queryParameters['tableFilterFieldName'] = requestParameters['tableFilterFieldName'];
        }

        if (requestParameters['mappingKey'] != null) {
            queryParameters['mappingKey'] = requestParameters['mappingKey'];
        }

        if (requestParameters['operator'] != null) {
            queryParameters['operator'] = requestParameters['operator'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/component-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListComponentTypesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async componentTypeControllerFindAll(requestParameters: ComponentTypeControllerFindAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListComponentTypesResponseDto> {
        const response = await this.componentTypeControllerFindAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async componentTypeControllerFindByIdRaw(requestParameters: ComponentTypeControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComponentTypeOneResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling componentTypeControllerFindById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/component-types/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComponentTypeOneResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async componentTypeControllerFindById(requestParameters: ComponentTypeControllerFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComponentTypeOneResponseDto> {
        const response = await this.componentTypeControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async componentTypeControllerUpdateRaw(requestParameters: ComponentTypeControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling componentTypeControllerUpdate().'
            );
        }

        if (requestParameters['updateComponentTypeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateComponentTypeRequestDto',
                'Required parameter "updateComponentTypeRequestDto" was null or undefined when calling componentTypeControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/component-types/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateComponentTypeRequestDtoToJSON(requestParameters['updateComponentTypeRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async componentTypeControllerUpdate(requestParameters: ComponentTypeControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.componentTypeControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ComponentTypeControllerFindAllMappingKeyEnum = {
    Atsscc: 'ATSSCC',
    Atssccsst: 'ATSSCCSST'
} as const;
export type ComponentTypeControllerFindAllMappingKeyEnum = typeof ComponentTypeControllerFindAllMappingKeyEnum[keyof typeof ComponentTypeControllerFindAllMappingKeyEnum];
/**
 * @export
 */
export const ComponentTypeControllerFindAllOperatorEnum = {
    Included: 'INCLUDED',
    NotIncluded: 'NOT_INCLUDED'
} as const;
export type ComponentTypeControllerFindAllOperatorEnum = typeof ComponentTypeControllerFindAllOperatorEnum[keyof typeof ComponentTypeControllerFindAllOperatorEnum];
